import React from 'react'

export function SignButton(props) {
    return (
        <button onClick={props.handle} type="button" className="btn btn-sm btn-primary">Подписать</button>
    );
}